<template>
  <div class="pages" :style="{ height: height + 'px' }">
    <navTop></navTop>
    <!-- 标题 -->
    <div class="box">
      <div class="box-img">
        <img src="../../assets/paysuccess.png" />
        <span>Payment successful</span>
      </div>
      <div class="box-btn" @click="goOrder">View order</div>
    </div>
    <div class="kefu"><img @click="isKefu = true"
        src="../../assets/kefu1.png" /></div>
    <kefu v-if="isKefu" style="margin-top: 130px;"></kefu>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import kefu from '../../components/kefu.vue';
export default {
  name: 'paySuccess',
  components: {
    navTop,
    kefu
  },
  data () {
    return {
      height: '', //页面高度
      isKefu: false //客服状态
    };
  },
  created () {
    if (!sessionStorage.getItem('uid')) {
      // this.$router.push({ path: '/' });
    } else {

    }
    this.height = window.innerHeight;
  },
  methods: {
    // 查看订单
    goOrder () {
      this.$router.push({ path: '/order' });
    }
  }
};
</script>

<style lang="scss" scoped>
.pages {
  background: #000;
  position: relative;
  .box {
    .box-img {
      margin-top: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 200px;
        height: 200px;
        display: block;
        margin-bottom: 48px;
      }
      span {
        font-size: 24px;
        color: #00faff;
        line-height: 1em;
      }
    }
    .box-btn {
      width: 728px;
      height: 104px;
      background: linear-gradient(
        90deg,
        rgba(29, 175, 170, 0.8) 0%,
        rgba(35, 254, 246, 0.8) 100%
      );
      font-size: 36px;
      font-weight: bold;
      color: #f6f6f6;
      line-height: 104px;
      text-align: center;
      margin: 138px auto 0;
    }
  }
  .kefu {
    position: absolute;
    top: 742px;
    right: 115px;
    width: 130px;
    height: 130px;
    img {
      width: 130px;
      height: 130px;
      display: block;
    }
  }
}
</style>
